import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// [Web UX 9 / T2, 2026-10-13] a dátumválasztók magyar feliratai (Cancel/OK/Select date helyett) — lásd utils/dateLocale.ts
import { HU_PICKER_LOCALE_TEXT } from './utils/dateLocale';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { FeedbackProvider } from './contexts/FeedbackContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import { UnsavedChangesProvider } from './contexts/UnsavedChangesContext';
import AuthWrapper, { LoginPage, RegisterPage, LOGIN_PATH, REGISTER_PATH } from './components/AuthWrapper';
import VerifyEmail from './components/VerifyEmail';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import VenuesPage from './components/VenuesPage';
import 'dayjs/locale/hu';

// App content component that uses the theme
const AppContent: React.FC = () => {
  const { currentTheme } = useTheme();

  return (
    <MuiThemeProvider theme={currentTheme}>
      <CssBaseline enableColorScheme />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="hu" localeText={HU_PICKER_LOCALE_TEXT}>
        {/* Globális visszajelzés (toast) és megerősítő ablak — minden képernyő ezeket használja
            a natív alert()/confirm() és a képernyőnként külön megoldott sikerjelzés helyett. */}
        <FeedbackProvider>
        <ConfirmProvider>
        <UnsavedChangesProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/helyszinek" element={<VenuesPage />} />
              {/* [Web UX 2. csomag – Belépés és munkamenet, 2026-10-03] Valódi belépési / regisztrációs
                  útvonal (jelentés 3.1; korábban az AuthWrapper belső állapota volt). A régi `/login` a
                  kiküldött linkek és könyvjelzők miatt átirányít. */}
              <Route path={LOGIN_PATH} element={<LoginPage />} />
              <Route path={REGISTER_PATH} element={<RegisterPage />} />
              <Route path="/login" element={<Navigate to={LOGIN_PATH} replace />} />
              <Route path="/*" element={<AuthWrapper />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        </UnsavedChangesProvider>
        </ConfirmProvider>
        </FeedbackProvider>
      </LocalizationProvider>
    </MuiThemeProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
